/**
 * @generated SignedSource<<3a4efd5b3018a62d240a950da34a26bc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreateViewInput = {
  description?: string | null | undefined;
  name: string;
  peopleFilters: any;
  projectFilters: any;
  usersAllocated?: ReadonlyArray<number> | null | undefined;
};
export type ViewCreateMutation$variables = {
  view: CreateViewInput;
};
export type ViewCreateMutation$data = {
  readonly createView: {
    readonly createdView: {
      readonly databaseId: number;
      readonly description: string | null | undefined;
      readonly id: string;
      readonly name: string;
      readonly peopleFilters: any;
      readonly projectFilters: any;
      readonly type: string;
      readonly userIds: ReadonlyArray<number>;
    };
  };
};
export type ViewCreateMutation = {
  response: ViewCreateMutation$data;
  variables: ViewCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "view"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "view"
      }
    ],
    "concreteType": "CreateViewPayload",
    "kind": "LinkedField",
    "name": "createView",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "DatabaseView",
        "kind": "LinkedField",
        "name": "createdView",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "databaseId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "projectFilters",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "peopleFilters",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userIds",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ViewCreateMutation",
    "selections": (v1/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ViewCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1a71157591bf5ebe00f26e26b8435cbd",
    "id": null,
    "metadata": {},
    "name": "ViewCreateMutation",
    "operationKind": "mutation",
    "text": "mutation ViewCreateMutation(\n  $view: CreateViewInput!\n) {\n  createView(input: $view) {\n    createdView {\n      id\n      databaseId\n      name\n      type\n      description\n      projectFilters\n      peopleFilters\n      userIds\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "28e81a7fb60f627f0f1be9a85cf8dde3";

export default node;
